var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "common-content",
    [
      _c("page-title", { attrs: { pageName: _vm.pageData.title } }),
      _c("div", { staticClass: "team-product" }, [
        _vm._v(_vm._s(_vm.pageData.content))
      ]),
      _vm._l(_vm.pageData.imgList, function(item) {
        return _c("div", { staticClass: "teamimgwrap" }, [
          _c("div", { staticClass: "imgcover" }),
          _c("img", { attrs: { src: item.url, alt: "" } })
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1ad1eae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1ad1eae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/us/teams/_id.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b1ad1eae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/us/teams/_id.vue
// module chunks = 5